module.exports = __webpack_public_path__ + "media/images/brands/brand-pk-5a2dbc2c5f47207bd6c4557fd1f82bbd.jpg";